import * as React from 'react';
import { cn } from '@/lib/utils';

const ProjectTimeline = React.forwardRef(({ className, ...props }, ref) => (
  <ul
    ref={ref}
    className={cn('project-timeline', 'm-0 list-none p-0', className)}
    {...props}
  />
));
ProjectTimeline.displayName = 'ProjectTimeline';

const ProjectTimelineItem = React.forwardRef(({ className, active, approved, ...props }, ref) => (
  <li
    ref={ref}
    className={cn(
      'project-timeline-item',
      'relative mb-2 flex cursor-pointer items-center gap-1 rounded-lg p-2 transition-colors',
      active ? 'active bg-primary-lightest' : 'opacity-80',
      approved && 'project-timeline-item-approved cursor-default bg-success font-bold text-white',
      !approved && 'before:absolute before:bottom-[-20px] before:left-[25px] before:top-[40px] before:z-0 before:w-[1px] before:bg-neutral-light before:content-[""] last:before:hidden',
      className
    )}
    {...props}
  />
));
ProjectTimelineItem.displayName = 'ProjectTimelineItem';

const ProjectTimelineVersion = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('project-timeline-version', 'relative z-[1] flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-solid border-white bg-primary-light text-[10px] font-bold text-white', className)}
    {...props}
  />
));
ProjectTimelineVersion.displayName = 'ProjectTimelineVersion';

const ProjectTimelineGroup = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('project-timeline-group', 'flex flex-grow flex-col', className)}
    {...props}
  />
));
ProjectTimelineGroup.displayName = 'ProjectTimelineGroup';

const ProjectTimelineText = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('project-timeline-text', 'text-[12px] font-semibold text-neutral-dark', className)}
    {...props}
  />
));
ProjectTimelineText.displayName = 'ProjectTimelineText';

const ProjectTimelineCreate = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('project-timeline-create', 'text-neutral-medium text-[12px]', className)}
    {...props}
  />
));
ProjectTimelineCreate.displayName = 'ProjectTimelineCreate';

export { ProjectTimeline, ProjectTimelineItem, ProjectTimelineVersion, ProjectTimelineGroup, ProjectTimelineText, ProjectTimelineCreate };
